import React from 'react'
import classNames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'
import PropTypes from 'prop-types'
import { useForm } from '../context'
import { useConfig } from '../../ConfigProvider'
import { CONTROL_SIZES, SIZES, LAYOUT } from '../../utils/constant'
import AlertIcon from '../../../../assets/images/personal/alert-icon.svg'
import ValidIcon from '../../../../assets/images/personal/pass-icon.svg'

const FormItem = React.forwardRef((props, ref) => {
    const {
        children,
        label,
        labelClass,
        errorMessage,
        invalid,
        className,
        layout,
        labelWidth,
        asterisk,
        style,
        size,
        extra,
        htmlFor,
        toolTips,
        tipsContent,
    } = props

    const formContext = useForm()
    const { controlSize } = useConfig()

    const formItemLabelHeight = size || formContext.size || controlSize
    const formItemLabelWidth = labelWidth || formContext.labelWidth
    const formItemLayout = layout || formContext.layout

    const getFormLabelLayoutClass = () => {
        switch (formItemLayout) {
            case LAYOUT.HORIZONTAL:
                return label
                    ? `h-${CONTROL_SIZES[formItemLabelHeight]} ${label && ''}`
                    : 'ltr:pr-2 rtl:pl-2'
            case LAYOUT.VERTICAL:
                return `mb-2`
            case LAYOUT.INLINE:
                return `h-${CONTROL_SIZES[formItemLabelHeight]} ${
                    label && 'ltr:pr-2 rtl:pl-2'
                }`
            default:
                break
        }
    }

    const formItemClass = classNames(
        'form-item',
        formItemLayout,
        className,
        invalid ? 'invalid' : '',
    )

    const formLabelClass = classNames(
        'form-label',
        label && getFormLabelLayoutClass(),
        labelClass
    )

    const formLabelStyle = () => {
        if (formItemLayout === LAYOUT.HORIZONTAL) {
            return { ...style, ...{ minWidth: formItemLabelWidth } }
        }

        return { ...style }
    }

    const enterStyle = { opacity: 1, marginTop: 3, bottom: -21 }
    const exitStyle = { opacity: 0, marginTop: -10 }
    const initialStyle = exitStyle

    return (
        <div ref={ref} className={formItemClass}>
            {label && (
                <label
                    htmlFor={htmlFor}
                    className={formLabelClass}
                    style={formLabelStyle()}
                >
                    {asterisk && (
                        <span className="text-red-500 ltr:mr-1 rtl:ml-1">*</span>
                    )}
                    {label}
                    {label && formItemLayout !== 'vertical' && ':'}
                    {extra && <span>{extra}</span>}
                    {toolTips && 
                        <div class="ml-2 relative flex flex-col justify-center border border-gray-75 w-4 h-4 rounded-lg  ">
                        <div class="group cursor-pointer relative inline-block text-center text-gray-75  text-xs ">?
                            <div class="opacity-0 w-40 bg-gray-25 text-xs text-white text-center rounded-lg py-2 absolute z-10 group-hover:opacity-100 bottom-full -ml-20 px-3 pointer-events-none">
                                {tipsContent && <p>{tipsContent}</p>}
                                
                            </div>
                        </div>
                    </div>}
                </label>
            )}
            <div
                className={ 
                    formItemLayout === LAYOUT.HORIZONTAL
                        ? 'w-full flex flex-col justify-center relative '
                        : ''
                }
            >
                {children}
                <AnimatePresence exitBeforeEnter>
                    {invalid && (
                        <div
                            className="form-explain"
                            // initial={initialStyle}
                            // animate={enterStyle}
                            // exit={exitStyle}
                            // transition={{ duration: 0.15, type: 'tween' }}
                        >
                            <div className='flex gap-1 items-center'> 
                            <img src={AlertIcon} alt='alert icon' className='h-4 w-4'/>{errorMessage}
                            </div>
                        </div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    )
})

FormItem.propTypes = {
    layout: PropTypes.oneOf([
        LAYOUT.HORIZONTAL,
        LAYOUT.VERTICAL,
        LAYOUT.INLINE,
    ]),
    size: PropTypes.oneOf([SIZES.LG, SIZES.SM, SIZES.MD]),
    labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    errorMessage: PropTypes.string,
    invalid: PropTypes.bool,
    asterisk: PropTypes.bool,
    extra: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    htmlFor: PropTypes.string,
    labelClass: PropTypes.string,
}

export default FormItem
